/* Kahaus: klik w kropkę koloru na karcie podmienia zdjęcie na wariant. */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.kahaus-dot-btn[data-kahaus-img]');
  if (!btn) return;
  e.preventDefault();
  const card = btn.closest('.card-wrapper') || btn.closest('.card');
  const img = card && card.querySelector('.card__media img');
  if (!img) return;
  img.removeAttribute('srcset');
  img.src = btn.dataset.kahausImg;
  const dots = btn.closest('.kahaus-card-dots');
  if (dots) {
    dots.querySelectorAll('.kahaus-dot-btn').forEach((b) => b.classList.toggle('is-active', b === btn));
  }
});

/* Kahaus: wybór języka dostosowuje kraj/walutę.
   Mapa język -> kraj; PL->PLN, RO->RON, HU->HUF, reszta strefa euro (EN->IE).
   Doklejamy country_code do formularza języka (capture — przed submitem Dawn),
   więc Shopify przełącza język I walutę jednym żądaniem. */
(function () {
  var LANG_COUNTRY = { pl: 'PL', en: 'IE', de: 'DE', fr: 'FR', it: 'IT', es: 'ES', nl: 'NL', ro: 'RO', hu: 'HU', sk: 'SK' };
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest && e.target.closest('.kahaus-loc-language .disclosure__link[data-value]');
      if (!link) return;
      var iso = (link.dataset.value || '').toLowerCase();
      var country = LANG_COUNTRY[iso];
      var form = link.closest('form');
      if (!country || !form) return;
      // przejmujemy submit: ustawiamy język I kraj razem, potem sami wysyłamy
      e.preventDefault();
      e.stopPropagation();
      var lc = form.querySelector('input[name="locale_code"]');
      if (lc) lc.value = iso;
      var cc = form.querySelector('input[name="country_code"]');
      if (!cc) {
        cc = document.createElement('input');
        cc.type = 'hidden';
        cc.name = 'country_code';
        form.appendChild(cc);
      }
      cc.value = country;
      HTMLFormElement.prototype.submit.call(form);
    },
    true
  );
})();
